(function () {
  'use strict';

  function normalizeRegistryValue(value) {
    return String(value ?? '')
      .normalize('NFKC')
      .trim()
      .toLocaleLowerCase()
      .replace(/\s+/g, ' ');
  }

	function initializeRegistry(root) {
	  if (!root || root.dataset.arcRegistryReady === 'true') return;
	  root.dataset.arcRegistryReady = 'true';

    const dataNode = root.querySelector('[data-arc-registry-data]');
    const form = root.querySelector('[data-arc-registry-form]');
    const input = root.querySelector('[data-arc-registry-input]');
    const guidance = root.querySelector('[data-arc-registry-guidance]');
    const results = root.querySelector('[data-arc-registry-results]');
    const notFound = root.querySelector('[data-arc-registry-not-found]');
	  const clear = root.querySelector('[data-arc-registry-clear]');
	  const status = root.querySelector('[data-arc-registry-status]');
	  const cards = Array.from(root.querySelectorAll('[data-arc-registry-card]'));
	  if (!dataNode || !form || !input || !results) return;
	  const searchPanel = form.closest('.arc-registry-search') || form;
	  if (guidance && guidance.parentElement !== searchPanel) searchPanel.appendChild(guidance);
	  if (results.parentElement !== searchPanel) searchPanel.appendChild(results);
	  let loading = root.querySelector('[data-arc-registry-loading]');
	  let searchTimer = 0;
	  if (!loading) {
	    loading = document.createElement('div');
	    loading.className = 'arc-registry-loading';
	    loading.setAttribute('role', 'status');
	    loading.setAttribute('aria-live', 'polite');
	    loading.setAttribute('data-arc-registry-loading', '');
	    loading.innerHTML = '<div class="arc-registry-loading-label"><span>Querying registry</span></div><div class="arc-registry-loading-track"><i></i></div>';
	    form.insertAdjacentElement('afterend', loading);
	  }

    let records = [];
    try {
      records = JSON.parse(dataNode.textContent || '[]');
    } catch (error) {
      records = [];
    }

	  if (!records.length && cards.length) {
	    records = cards.map((card) => ({
	      index: Number(card.dataset.registryIndex),
	      brand_name: card.querySelector('h3')?.textContent || '',
	      certificate_id: card.querySelector('.arc-registry-brand-identity p')?.textContent || '',
	      search_aliases: [],
	    }));
	  }

	  const searchable = records.map((record) => {
	    const aliases = Array.isArray(record.search_aliases)
	      ? record.search_aliases
	      : record.search_aliases ? [record.search_aliases] : [];
	    const brandWords = String(record.brand_name || '')
	      .split(/[\s,;/|]+/)
	      .filter((word) => word.length > 1);
	    const normalizedCandidates = new Set([
	      record.brand_name,
	      record.certificate_id,
	      ...aliases,
	      ...brandWords,
	    ].map(normalizeRegistryValue).filter(Boolean));
	    return { record, normalizedCandidates };
	  });

    function updateUrl(value) {
      const url = new URL(window.location.href);
      if (value) url.searchParams.set('brand', value);
      else url.searchParams.delete('brand');
      window.history.replaceState({}, '', url);
    }

	  function resetRegistry(updateHistory = true) {
	    window.clearTimeout(searchTimer);
	    loading?.classList.remove('is-active');
	    input.value = '';
	    cards.forEach((card) => { card.hidden = true; });
      if (notFound) notFound.hidden = true;
      results.hidden = true;
      if (guidance) guidance.hidden = false;
      if (status) status.textContent = '';
      if (updateHistory) updateUrl('');
    }

	  function renderRegistry(rawQuery, updateHistory = true) {
	    const query = normalizeRegistryValue(rawQuery);
	    if (!query) {
	      resetRegistry(updateHistory);
        return;
      }

      const matches = searchable
        .filter(({ normalizedCandidates }) => normalizedCandidates.has(query))
        .map(({ record }) => Number(record.index));
      const matchSet = new Set(matches);

      cards.forEach((card) => {
        card.hidden = !matchSet.has(Number(card.dataset.registryIndex));
      });
      if (notFound) notFound.hidden = matches.length !== 0;
      results.hidden = false;
      if (guidance) guidance.hidden = true;
      if (status) status.textContent = String(matches.length);
	      if (updateHistory) updateUrl(String(rawQuery).trim());
	    }

	  function searchRegistry(rawQuery, updateHistory = true, delay = true) {
	    const query = normalizeRegistryValue(rawQuery);
	    window.clearTimeout(searchTimer);
	    if (!query) {
	      resetRegistry(updateHistory);
	      return;
	    }
	    cards.forEach((card) => { card.hidden = true; });
	    if (notFound) notFound.hidden = true;
	    results.hidden = true;
	    if (guidance) guidance.hidden = true;
	    loading?.classList.add('is-active');
	    const submit = form.querySelector('[type="submit"]');
	    submit?.setAttribute('aria-busy', 'true');
	    if (submit) submit.disabled = true;
	    searchTimer = window.setTimeout(() => {
	      loading?.classList.remove('is-active');
	      submit?.removeAttribute('aria-busy');
	      if (submit) submit.disabled = false;
	      renderRegistry(rawQuery, updateHistory);
	    }, delay ? 950 : 0);
	  }

	  form.addEventListener('submit', (event) => {
	    event.preventDefault();
	    searchRegistry(input.value);
	  });
    clear?.addEventListener('click', () => resetRegistry());

    const initialQuery = new URLSearchParams(window.location.search).get('brand') || '';
	  if (initialQuery) {
	    input.value = initialQuery;
	    searchRegistry(initialQuery, false);
	  } else {
	    resetRegistry(false);
	  }
  }

  function start() {
    document.querySelectorAll('[data-arc-registry-root]').forEach(initializeRegistry);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
